/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskDimension
 */
export interface RiskDimension {
  /**
   *
   * @type {number}
   * @memberof RiskDimension
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskDimension
   */
  name: string;
}

/**
 * Check if a given object implements the RiskDimension interface.
 */
export function instanceOfRiskDimension(value: object): value is RiskDimension {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function RiskDimensionFromJSON(json: any): RiskDimension {
  return RiskDimensionFromJSONTyped(json, false);
}

export function RiskDimensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskDimension {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function RiskDimensionToJSON(value?: Omit<RiskDimension, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
